import { useSelector } from "react-redux"

const FavIcon = () => {
  const ciabName = useSelector((s) => s.configuration?.ciabName)
  return <link rel="icon" href={`/favicons/${ciabName}.ico`} sizes="any" />
}

export default FavIcon
